import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { env } from './env';
import { initSentry } from './sentry';
import './styles/globals.css';
import App from './app';

// Initialize Sentry before anything else so it captures early errors
initSentry(env);

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
